import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { BaselineCheck } from './baseline-check.model';
import { BaselineCheckResponse, GetRiskMapTreeFiltersQuery } from '../../../../graphql/generated';

export const BaselineCheckActions = createActionGroup({
  source: 'BaselineCheck/API',
  events: {
    'Load BaselineCheck': props<{ legalEntityId: string, campaignId: string, params?: any, filtering?: boolean }>(),
    'Load BaselineCheck Success': props<{ baselineCheck: BaselineCheckResponse[], filtering?: boolean }>(),
    'Load BaselineCheck Failure': props<{ error: any }>(),
    'Load All BaselineCheck': props<{ legalEntityId: string, campaignId: string, params?: any, filtering?: boolean }>(),
    'Load All BaselineCheck Success': props<{ baselineCheck: GetRiskMapTreeFiltersQuery['riskMapTreeFields'], filtering?: boolean }>(),
    'Load All BaselineCheck Failure': props<{ error: any }>(),
    'Add BaselineCheck': props<{ baselineCheck: BaselineCheck }>(),
    'Upsert BaselineCheck': props<{ baselineCheck: BaselineCheck }>(),
    'Add BaselineChecks': props<{ baselineChecks: BaselineCheck[] }>(),
    'Upsert BaselineChecks': props<{ baselineChecks: BaselineCheck[] }>(),
    'Delete BaselineCheck': props<{ id: string }>(),
    'Delete BaselineChecks': props<{ ids: string[] }>(),
    'Clear BaselineChecks': emptyProps(),
    'Update BaselineCheck': props<{ id: string, icsRationale: string, irRationale: string, selection: string }>(),
    'Update BaselineCheck Success': props<{ id: string, icsRationale: string, irRationale: string, selection: string, cptId: string, }>(),
    'Update BaselineCheck Failure': props<{ error: any, selection: string, id: string, }>(),
    'Create BaselineCheck': props<{
      campaignId: string,
      cptId: string,
      icsRationale: string,
      irRationale: string,
      legalEntityId: string,
      selection: string
    }>(),
    'Create BaselineCheck Success': props<{ id: string, icsRationale: string, irRationale: string, selection: string, cptId: string, }>(),
    'Create BaselineCheck Failure': props<{ error: any, selection: string, id: string, }>()
  }
});
